import {
  Spacing
} from 'UI'

export default theme => ({
  paperClass: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: () => Spacing(5),
    margin: ({ margin }) => margin || null
  },
  iconClass: {
    color: theme.secondary[0],
    padding: () => Spacing(0, 2, 0, 0)
  },
  infoGroup: {
    display: 'flex'
  },
  col: {
    display: 'flex',
    flexDirection: 'column'
  },
  col1: {
    marginRight: 16
  },
  itemsClass: {
    alignItems: 'center'
  }
})
